import React from "react";

// reactstrap components
import { Button, Container, Row, Col } from "reactstrap";

import { MultiLang, Determinator } from "react-multi-language";

class Paragraphs extends React.Component {
  render() {
    return (
      <>
        <section className="section section-lg section-nucleo-icons pb-250">
          <Container>
            <Row className="justify-content-center">
              <Col className="text-center" lg="8">
                <h2 className="display-3">
                  <Determinator>
                    {{
                      en: "Shatin Caverns - Community Liaison Centre (CLC)",
                      tw: "沙田岩洞 - 社區聯絡中心",
                      cn: "沙田岩洞 - 社区联络中心",
                    }}
                  </Determinator>
                </h2>
                <p className="lead">
                  <br />
                  The construction of CLC adopted Modular Integrated Construction (MiC) and integrated with Building Information Modeling (BIM), which shortened the construction time, improved the accuracy of material estimation and reduced wastage.
                  <br />
                  <br />
                  The meeting room in CLC will be opened for public booking. Please stay close to our website’s announcement.
                </p>
                <div className="btn-wrapper">
                  {/* <Button
                    color="primary"
                    href="https://demos.creative-tim.com/argon-design-system-react/#/documentation/icons?ref=adsr-landing-page"
                  >
                    View demo icons
                  </Button>
                  <Button
                    className="mt-3 mt-md-0"
                    color="default"
                    href="https://nucleoapp.com/?ref=1712"
                    target="_blank"
                  >
                    View all icons
                  </Button> */}
                </div>
              </Col>
            </Row>
            <div className="blur--hover">
              <a href="">
                <div className="icons-container blur-item mt-5 on-screen">
                  <i className="icon ni ni-diamond" />
                  <i className="icon icon-sm ni ni-album-2" />
                  <i className="icon icon-sm ni ni-app" />
                  <i className="icon icon-sm ni ni-atom" />
                  <i className="icon ni ni-bag-17" />
                  <i className="icon ni ni-bell-55" />
                  <i className="icon ni ni-credit-card" />
                  <i className="icon icon-sm ni ni-briefcase-24" />
                  <i className="icon icon-sm ni ni-building" />
                  <i className="icon icon-sm ni ni-button-play" />
                  <i className="icon ni ni-calendar-grid-58" />
                  <i className="icon ni ni-camera-compact" />
                  <i className="icon ni ni-chart-bar-32" />
                </div>
                <span className="blur-hidden h5 text-success">
                  more are coming soon
                </span>
              </a>
            </div>
          </Container>
        </section>

        <MultiLang lang={this.props.languageState.lang} />
      </>
    );
  }
}

export default Paragraphs;
